import { sessionId } from './attribution';

/**
 * Landings comparées dans le cockpit (Acquisition → « Landing actuelle vs Nutrition V2 »).
 * Une visite = une session (`openbro_sid`), rattachée à la première landing ouverte dans l'onglet.
 * Événements envoyés à POST /api/analytics/lp (netlify-proxy/worker.js, sessions `ses:<sid>` dans AnalyticsLog) :
 *   landing_view, content_view, pricing_view, hero_cta_click, bottom_cta_click, ping (durée), leave.
 * checkout_open et purchase sont enregistrés par le Worker (création de la session Stripe, page /success).
 */

const ENDPOINT = '/api/analytics/lp';
const UTM_STORE = 'openbro_session_utm';

/** Chemin → variante. Garder aligné avec LANDING_VARIANTS dans le Worker. */
// `/` n'en fait plus partie depuis le 28/10/2026 : c'est la page mentorat (V60), payée au prix du mentorat.
const VARIANTS = { '/eat': 'nutrition_v2', '/eatv2': 'eat_v2', '/v70': 'current_v70' };

/** Sections qui déclenchent content_view et pricing_view, par variante. */
export const VIEW_TARGETS = {
  current_v70: { content_view: '#resultats', pricing_view: '#prix' },
  nutrition_v2: { content_view: '#included', pricing_view: '#pricing' },
  eat_v2: { content_view: '#included', pricing_view: '#pricing' },
};

/** Boutons du haut de page (hero_cta_click). Tous les autres boutons d'achat comptent en bottom_cta_click. */
const HERO_BUTTONS = new Set(['eat-hero', 'v70-hero', 'v70-launch', 'v70-hero-urge', 'v70-hero-sub']);

const PARAMS = [
  ['utm_source', 'source'], ['utm_medium', 'medium'], ['utm_campaign', 'campaign'],
  ['utm_content', 'content'], ['utm_term', 'term'], ['fbclid', 'fbclid'],
];

export function landingVariant(path = window.location.pathname) {
  const clean = String(path || '/').replace(/\/+$/, '') || '/';
  return VARIANTS[clean] || '';
}

export function ctaEvent(button) {
  return HERO_BUTTONS.has(button) ? 'hero_cta_click' : 'bottom_cta_click';
}

/**
 * UTMs et fbclid de la visite en cours : ceux de l'URL d'arrivée, gardés pour tout l'onglet
 * (ils disparaissent de l'URL dès qu'on change de page). Un nouveau clic pub dans le même onglet les remplace.
 */
export function sessionUtm() {
  const query = new URLSearchParams(window.location.search);
  const fresh = {};
  PARAMS.forEach(([param, key]) => {
    const value = query.get(param);
    if (value) fresh[key] = value.slice(0, key === 'fbclid' ? 255 : 120);
  });
  try {
    if (Object.keys(fresh).length) {
      sessionStorage.setItem(UTM_STORE, JSON.stringify(fresh));
      return fresh;
    }
    return JSON.parse(sessionStorage.getItem(UTM_STORE) || '{}') || {};
  } catch {
    return fresh;
  }
}

/** Appareil déjà connu comme celui de Gaut ou d'un membre : ?nonotif=1 (VisitBeacon) ou session membre ouverte. */
export function isInternalDevice() {
  try {
    return localStorage.getItem('openbro_visit_mute') === '1' || Boolean(localStorage.getItem('token'));
  } catch {
    return false;
  }
}

export function trackLanding(event, extra = {}) {
  const variant = landingVariant();
  if (!variant) return;
  const { beacon, ...fields } = extra;
  const body = JSON.stringify({
    sid: sessionId(),
    variant,
    event,
    page: window.location.pathname,
    utm: sessionUtm(),
    internal: isInternalDevice() || undefined,
    ...fields,
  });
  if (beacon && navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }))) return;
  fetch(ENDPOINT, { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true }).catch(() => {});
}
